import { render, staticRenderFns } from "./DoubleSimulator.vue?vue&type=template&id=f53e2814&"
import script from "./DoubleSimulator.vue?vue&type=script&lang=js&"
export * from "./DoubleSimulator.vue?vue&type=script&lang=js&"
import style0 from "./DoubleSimulator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports